import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Plus, Trash2 } from 'lucide-react';

export function AuctionLotsTab({ lots, setLots, items, setItems }) {
  const addLot = () => {
    setLots([...lots, {
      lot_id: `lot_${Date.now()}`, lot_number: lots.length + 1,
      name: `Lot ${lots.length + 1}`, description: '',
    }]);
  };

  const updateLot = (idx, field, value) => {
    const updated = [...lots];
    updated[idx] = { ...updated[idx], [field]: value };
    setLots(updated);
  };

  const removeLot = (idx) => {
    const lotId = lots[idx].lot_id;
    setLots(lots.filter((_, i) => i !== idx));
    setItems(items.map(i => i.lot_id === lotId ? { ...i, lot_id: '' } : i));
  };

  return (
    <div className="space-y-4 py-2" data-testid="auction-lots-tab">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold">Lot Groupings</h3>
          <p className="text-xs text-slate-500">Optionally group items into lots for lot-based bidding. Suppliers bid per lot rather than per item.</p>
        </div>
        <Button size="sm" onClick={addLot} className="bg-indigo-600 hover:bg-indigo-700" data-testid="add-lot-btn">
          <Plus className="w-3.5 h-3.5 mr-1" /> Add Lot
        </Button>
      </div>

      {lots.length === 0 ? (
        <div className="text-center py-8 text-slate-400">
          <p className="text-sm">No lots defined. For lot-based auctions, create lots here then assign items to them in the Items tab.</p>
        </div>
      ) : (
        lots.map((lot, idx) => {
          const lotItems = items.filter(i => i.lot_id === lot.lot_id);
          return (
            <div key={lot.lot_id || idx} className="border rounded-lg p-4" data-testid={`lot-${idx}`}>
              <div className="flex items-start gap-3">
                <div className="bg-rose-100 text-rose-700 rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm flex-shrink-0">
                  {idx + 1}
                </div>
                <div className="flex-1 space-y-2">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <Label className="text-xs">Lot Name</Label>
                      <Input value={lot.name} onChange={e => updateLot(idx, 'name', e.target.value)} className="h-8 text-sm" />
                    </div>
                    <div>
                      <Label className="text-xs">Description</Label>
                      <Input value={lot.description} onChange={e => updateLot(idx, 'description', e.target.value)} className="h-8 text-sm" placeholder="Optional" />
                    </div>
                  </div>
                  {lotItems.length > 0 ? (
                    <div className="text-xs text-slate-500 bg-slate-50 rounded p-2">
                      {lotItems.length} item(s) assigned: {lotItems.map(i => i.description || `Line ${i.line_number}`).join(', ')}
                    </div>
                  ) : (
                    <p className="text-xs text-amber-600">No items assigned to this lot yet. Go to the Items tab to assign items.</p>
                  )}
                </div>
                <Button size="sm" variant="ghost" onClick={() => removeLot(idx)} className="text-red-400 hover:text-red-600 h-7 px-2">
                  <Trash2 className="w-3.5 h-3.5" />
                </Button>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
